const callCenterFeatures = () => window.chatwootConfig?.teletelFeatures || {};

export const isTeletelCallCenterGloballyEnabled = () =>
  Boolean(callCenterFeatures().callCenter);

export const isTeletelCallCenterEnabledForAccount = accountId => {
  const features = callCenterFeatures();
  const accountIds = Array.isArray(features.callCenterAccountIds)
    ? features.callCenterAccountIds
    : [];

  return (
    Boolean(features.callCenter) &&
    accountIds.map(String).includes(String(accountId))
  );
};

export const visibleTeletelPermissionGroups = groups =>
  isTeletelCallCenterGloballyEnabled()
    ? groups
    : groups.filter(group => group.key !== 'CALL_CENTER');
